import * as React from 'react'
import '../styles/AddPictures.scss'
import { AttachmentParams } from '../types/AttachmentParams'
import { LoadingSpinner } from './LoadingSpinner'
import { IMAGES_MAX_NUMBER } from '../constants/jobDetails-constants'
import UploadedImages from './UploadedImages'
import { StringResources } from '../localization/StringResources'
import { Strings } from '../localization'

interface UploaderProps {
  onChangeImg: Function
  img: string
  name: string
  files: Array<any>
  handleImageRemoval: (id: string) => void
  removeAllImages: () => void
  handleImageClick: (photoIndex: number) => void
  onNumberOfBags: (numberOfBags) => void
  isImagesMaxNumber: boolean
  isLoading?: boolean
  jobCategoryName: string
}

interface UploaderStates {
  imagesPreviewUrl: string | ArrayBuffer | null,
  file: string
  files: Array<any> | null
}

export class Uploader extends React.Component<UploaderProps, UploaderStates> {
  fileInput: any
  constructor(props: any) {
    super(props)
    this.state = {
      file: '',
      imagesPreviewUrl: '',
      files: this.props.files
    }
  }

  componentWillMount() {
    this.props.onNumberOfBags(null)
    this.setState({
      imagesPreviewUrl: this.props.img,
      files: this.props.files
    })
  }

  _handleImageChange = async (e: any) => {
    e.preventDefault()
    e.persist()

    let reader = new FileReader()
    let file = e.target.files[0]

    reader.onloadend = () => {
      this.setState({
        file: file,
        imagesPreviewUrl: reader.result
      })
      
      this.props.onChangeImg(this.state.imagesPreviewUrl, e)
    }

    reader.readAsDataURL(file)
  }

  componentWillReceiveProps(nextProps: any) {
    if (this.props.jobCategoryName !== nextProps.jobCategoryName) {
      this.props.removeAllImages()
    }
    this.setState({
      files: nextProps.files
    })
  }

  handleIconClick = (event: any) => {
    // tslint:disable-next-line:radix
    let iconIndex = parseInt(event.target.id)
    this.props.handleImageClick(iconIndex)
  }

  render() {
    let isLoading = this.props.isLoading ? this.props.isLoading : false
    let maxImgs = this.state.files ? this.state.files.length >= IMAGES_MAX_NUMBER : false

    return (
      <div className="Pickup-info" >

        <div className="title">{StringResources.getString(Strings.Components.Uploader.Title)}</div>
        <div className="list list-contant mt">
          {
            this.props.files && this.props.files !== null ? this.props.files.map((file: AttachmentParams, index: number) => (
              <UploadedImages
                key={file.id}
                handleIconClick={this.handleIconClick}
                index={index}
                file={file}
                isBadgeNeeded={true}
                handleImageRemoval={this.props.handleImageRemoval}
              />
            )) : null
          }
          {
            !maxImgs && isLoading &&
            <label className="show-uploaded-file">
              <LoadingSpinner show={isLoading} classes="shadowForImg" />
            </label>
          }
          {
            !maxImgs ? this.props.isImagesMaxNumber ? null :
              <label className="custom-file-upload">
                <input
                  // ref={elem => this.fileInput = elem}
                  className="fileInput"
                  type="file"
                  accept="image/*"
                  onChange={this._handleImageChange}
                  name={this.props.name}
                  tabIndex={0}
                />
                <div className="upload-icon" />
              </label>
              : null
          }
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/AddPictures.tsx